import styles from './pharmacy-selection-description.module.css';
import { useBranding } from '@/outlets/branding-outlet';
import clsx from 'clsx';

interface PharmacySelectionDescriptionProps {
  className?: string;
}

export function PharmacySelectionDescription({ className }: PharmacySelectionDescriptionProps) {
  const { pharmacySelectionDescription } = useBranding();

  if (!pharmacySelectionDescription) {
    return null;
  }

  return (
    <div
      className={clsx(styles.container, className)}
      dangerouslySetInnerHTML={{ __html: pharmacySelectionDescription }}
    />
  );
}
